import React from "react";
import { object } from "prop-types";
import { useLocation } from "react-router-dom";
import { PageSpinner } from "../components/generic/spinners";

import queryString from "query-string";

export const Callback = ({ auth }) => {
  const location = useLocation();
  const parsed = queryString.parse(location.search);

  auth.callback(parsed.access_token);
  return <PageSpinner text={"Processing Login..."} />;
};

Callback.propTypes = {
  auth: object
};
